type ApiMessagesType = Record<string, string>;

export enum NotificationMessages {
  ADDRESS_ADDED = 'Address added.',
  ADDRESS_DELETED = 'Address deleted.',
  ADDRESS_UPDATED = 'Address updated.',
  AVAILABLE_ITEMS_ADDED = 'Available items added to the cart.',
  ALREADY_ORDERED = 'Already ordered.',
  BACK_IN_STOCK = 'We will notify when the item is back in stock',
  CART_UPDATED = 'Cart updated.',
  CONTACT_FORM_SUBMITTED = 'Form submitted!',
  DEFAULT_ERROR = 'Error, something went wrong, please try again!',
  LINK_COPIED = 'Link copied.',
  LOGIN_FAILED = 'Error, login failed.',
  MAX_QUANTITY_REACHED = "Max quantity reached, can't add more.",
  NEWSLETTER_SUBSCRIBED = 'Thanks for subscribing!',
  ORDER_ITEMS_NOT_AVAILABLE = 'Order items not available',
  PASSWORD_UPDATED = 'Password updated.',
  PRODUCT_ADDED = 'Product added.',
  PRODUCT_REMOVED = 'Product removed.',
  PROFILE_UPDATED = 'Profile updated',
  SUCCESS = 'Success!',
}

export const API_MESSAGES: ApiMessagesType = {
  BAD_REQUEST: 'Bad Request',
  COULD_NOT_LOAD_REVIEWS: 'Could not load reviews',
  COULD_NOT_LOAD_REVIEW_SUMMARY: 'Could not load review summary',
  CUSTOMER_ALREADY_MEMBER: 'Customer already a member',
  CUSTOMER_NOT_CREATED: 'Customer not created',
  CUSTOMER_NOT_VALID: 'Customer not valid',
  LIST_NOT_ALTERED: 'List not altered',
  LIST_NOT_CREATED: 'List not created',
  LIST_NOT_RECEIVED: 'List not received',
  LIST_REGID_FAILED: 'Regid generate failed',
  LIST_SYNC_FAILED: 'List sync failed',
  LOGIN_FAILED: 'Login Failed',
  NOT_FOUND: 'Not found',
  NOT_FOUND_INSTAGRAM: 'Instagram access for organization not found',
  NOT_FOUND_SHOPIFY_CUSTOMER: 'Shopify customer not found',
  NOT_SUBSCRIBED_TO_BACK_IN_STOCK: 'Not subscribed to back in stock notification',
  ORGANIZATION_MEMBER_NOT_VALID: 'Organization member not valid',
  ORGANIZATION_PERMISSION: 'Organization permissions not valid',
  REFRESH_FAILED: 'Token refresh failed',
  REGISTRATION_FAILED: 'Registration failed',
  UNAUTHORIZED: 'Unauthorized',
};

export enum STOREFRONT_API_MESSAGES {
  NOT_LOADED = 'Data not loaded',
}

export const API_STATUS_CODE_MESSAGES = {
  STATUS_200: 'Success',
  STATUS_400: 'Error',
  STATUS_500: 'API System Error',
};

export const STOREFRONT_API_STATUS_CODE_MESSAGES = {
  STATUS_200: 'Success',
  STATUS_400: 'Error',
  STATUS_500: 'Storefront API System Error',
};
